import { RuntimeModel, http } from '@kunlun/dependencies';

/**
 * 获取物流公司
 *
 * @param {RuntimeModel} rModel
 * @param {{ariesIssuingMethodEnum: string}} params
 * @return {*}
 */
export async function fetchLogisticsProviders(rModel: RuntimeModel, params: { ariesIssuingMethodEnum: string }) {
  const mutation = `
    mutation {
      sellerDistributionCreateOrderParamMutation {
        fetchLogisticsProviders(data: { ariesIssuingMethodEnum: ${params.ariesIssuingMethodEnum} }) {
          id #物流公司id
          code #物流公司code
          name #物流公司名称
        }
      }
    }
  `;

  const res = await http.mutate<any[]>(rModel.moduleName, mutation);
  return res.data.sellerDistributionCreateOrderParamMutation.fetchLogisticsProviders;
}
